import { makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { colorPalette, spacings } from '../../../../theme';

interface Props {
  pageIndex: number;
  pagesCount: number;
}

export const KnowEachOtherCarouselPager = (props: Props): React.ReactElement => {
  const { pageIndex, pagesCount } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {[...Array(pagesCount).keys()].map((_, index) => (
        <div className={classNames(classes.page, index === pageIndex ? classes.active : classes.inactive)} />
      ))}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: spacings.xxlarge,
  },
  page: {
    marginLeft: 6,
    marginRight: 6,
  },
  active: {
    width: 12,
    height: 12,
    borderRadius: 6,
    backgroundColor: colorPalette.primaryColorBlue._500,
  },
  inactive: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: colorPalette.purpleGray._500,
    opacity: 0.3,
  },
}));
